import type { AssistantUiAction } from '@/api/assistant/assistantApi.types';
import type { RealtimeFunctionCall } from './realtimeEvents';

const PATIENT_TAB_BY_LOOKUP_TOOL: Record<string, string> = {
  get_previous_session_notes: 'sessionNotes',
  get_patient_overview: 'overview',
};

const PATIENT_DESTINATION = 'patient_detail';

function readObject(json: string): Record<string, unknown> | null {
  try {
    const parsed: unknown = JSON.parse(json);
    return typeof parsed === 'object' && parsed !== null && !Array.isArray(parsed)
      ? (parsed as Record<string, unknown>)
      : null;
  } catch {
    return null;
  }
}

export function patientScreenForVoiceLookup(
  call: RealtimeFunctionCall,
  serverOutput: string
): AssistantUiAction | null {
  const patientTab = PATIENT_TAB_BY_LOOKUP_TOOL[call.name];
  if (patientTab === undefined) {
    return null;
  }
  const output = readObject(serverOutput);
  if (output === null || 'error' in output) {
    return null;
  }
  const callArguments = readObject(call.argumentsJson);
  const patientId = callArguments === null ? undefined : callArguments.patient_id;
  if (typeof patientId !== 'string' || patientId === '') {
    return null;
  }
  return {
    actionId: 'voice-lookup-' + call.callId,
    kind: 'navigate',
    destination: PATIENT_DESTINATION,
    entityId: patientId,
    patientTab,
    targets: [],
    caption: null,
  };
}
